import { theme } from 'twin.macro'

export const colors = {
  background: theme`colors.background`,
  canvas: theme`colors.canvas`,
  flavors: {
    regular: theme`colors.flavors.regular`,
    chocolate: theme`colors.flavors.chocolate`,
    strawberry: theme`colors.flavors.strawberry`,
  }
}